import { UI_TOKENS } from './uiTokens';

/** Shared layout and field styles for module pages (Applications, Settings, Security, IGA, etc.). */
/** AppBar (64) + Layout main vertical padding p:3 (48). */
const PAGE_LOADER_MIN_HEIGHT = 'calc(100dvh - 112px)';

export const PAGE = {
  padding: { p: 3 } as const,
  /** Full-pane centered spinner (horizontal + vertical) inside Layout. */
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: PAGE_LOADER_MIN_HEIGHT,
    boxSizing: 'border-box' as const,
  },
  title: { fontSize: '1.1rem', fontWeight: 700, lineHeight: 1.2 } as const,
  subtitle: { fontSize: UI_TOKENS.text.buttonSm, color: 'text.secondary', mt: 0.25 } as const,
  sectionTitle: {
    fontSize: UI_TOKENS.text.bodySm,
    fontWeight: 700,
    color: 'text.secondary',
    textTransform: 'uppercase' as const,
    letterSpacing: 0.4,
  },
  subsectionTitle: { fontSize: UI_TOKENS.text.bodySm, fontWeight: 600 } as const,
  body: { fontSize: UI_TOKENS.text.bodySm } as const,
  helper: { fontSize: UI_TOKENS.text.helper, color: 'text.secondary' } as const,
};

export const FIELD_SX = {
  '& .MuiInputBase-input': { fontSize: UI_TOKENS.text.bodySm },
  '& .MuiInputLabel-root': { fontSize: UI_TOKENS.text.bodySm },
};

export const SELECT_SX = {
  ...FIELD_SX,
  '& .MuiSelect-select': { fontSize: UI_TOKENS.text.bodySm },
};

export const MENU_PROPS = {
  PaperProps: {
    sx: {
      '& .MuiMenuItem-root': {
        fontSize: UI_TOKENS.text.bodySm,
        minHeight: UI_TOKENS.menu.itemMinHeight,
        py: UI_TOKENS.menu.itemPaddingY,
      },
    },
  },
};

export const CARD_SX = {
  borderRadius: 2,
  borderColor: 'divider',
  boxShadow: 'none',
};

export const TABS_SX = {
  minHeight: 48,
  '& .MuiTab-root': {
    minHeight: 48,
    textTransform: 'none',
    fontSize: UI_TOKENS.text.buttonSm,
    fontWeight: 600,
    color: 'text.secondary',
    px: 2,
    '&.Mui-selected': { color: 'primary.main' },
  },
  '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
};

export const BTN_SM = { fontSize: UI_TOKENS.text.bodySm, py: UI_TOKENS.menu.itemPaddingY };
